import routerOptions0 from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}